import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ScriptLoaderService} from "../../../services/scripts.service";
import {Installment} from "../../../model/view/Product";

@Component({
  selector: 'v-product-installment',
  templateUrl: './product-installment.component.html',
  styleUrls: ['./product-installment.component.scss']
})
export class ProductInstallmentComponent implements OnInit{
  @Input() installment: Installment;
  poActive = false;

  constructor(private scriptLoaderService: ScriptLoaderService) {
  }

  ngOnInit() {
    this.installment.payuInstallmentEnabled && this.installPayu()
  }

  async installPayu() {
    const options = {
      creditAmount: this.installment.price.value,
      posId: this.installment.posId,
      key: this.installment.key,
      showLongDescription: true
    }
    try {
      await this.scriptLoaderService.load('payu-installament');
      const results = await window['OpenPayU']?.Installments.miniInstallment('#payubutton', options);
    }
    catch (err) {
      console.error(err)
    }
  }

  closePO(event) {
    event.stopPropagation();
    this.poActive = false;
  }
}
